import Axios from "axios";
var RobotService = (function () {
    function RobotService() {
    }
    RobotService.prototype.getRobotInfo = function (params) {
        return Axios.get('/supplierclientapi/robot/get', { params: params });
    };
    RobotService.prototype.clearRobotMessage = function (params) {
        return Axios.post('/supplierclientapi/robot/clear_message', params);
    };
    RobotService.prototype.updateRobotName = function (params) {
        return Axios.post('/supplierclientapi/robot/update_name', params);
    };
    RobotService.prototype.getRobotMessageList = function (params) {
        return Axios.get('/supplierclientapi/robot/message_list', { params: params });
    };
    RobotService.createInstance = function () {
        RobotService.getInstance();
    };
    RobotService.getInstance = function () {
        return this._instance || (this._instance = new this());
    };
    return RobotService;
}());
export default RobotService;
